<script setup lang="ts">
import { Head } from "@inertiajs/vue3"
import { computed } from "vue"

import Heading from "@/components/Heading.vue"
import SetSettingDialog from "@/components/manager/SetSettingDialog.vue"
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableHeader,
//   TableRow,
// } from "@/components/ui/table"
import AppLayout from "@/layouts/AppLayout.vue"
import { managerAppSettingsPath, managerDashboardPath } from "@/routes"
import type { BreadcrumbItem } from "@/types"
import type { ManagerAppSettingsIndex } from "@/types/serializers"

const props = defineProps<ManagerAppSettingsIndex>()

const breadcrumbs: BreadcrumbItem[] = [
  {
    title: "Manager Dashboard",
    href: managerDashboardPath(),
  },
  {
    title: "Configura tu App",
    href: managerAppSettingsPath(),
  },
]

const settings = computed(() => [props.telework, props.study])
</script>

<template>
  <Head :title="breadcrumbs[breadcrumbs.length - 1].title" />

  <AppLayout :breadcrumbs="breadcrumbs">
    <div class="layout-container">
      <Heading
        title="Configura tu App"
        description="Aquí podrás configurar los parámetros de tu aplicación para adaptarla a las necesidades de tu empresa."
      />

      <!-- <Table>
        <TableHeader>
          <TableRow>
            <TableHead>ID</TableHead>
            <TableHead>Name</TableHead>
            <TableHead>Acción</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          <TableRow v-for="setting in settings" :key="setting.id">
            <TableCell>{{ setting.id }}</TableCell>
            <TableCell>{{ setting.name }}</TableCell>
            <TableCell>
              <SetSettingApproveDialog :setting="setting" />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table> -->

      <div class="grid grid-cols-2 gap-4">
        <SetSettingDialog
          v-for="setting in settings"
          :key="setting.id"
          :setting="setting"
        />
      </div>
    </div>
  </AppLayout>
</template>
